/**
 * avatar theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/%40chakra-ui/react%403.0.0/packages/react/src/theme/recipes/avatar.ts
 */
import { defineSlotRecipe } from '@chakra-ui/react';
import { avatarAnatomy } from '@chakra-ui/react/anatomy';
export const avatar = defineSlotRecipe({
    slots: avatarAnatomy.keys(),
    base: {},
    variants: {
        variant: {
            outline: {
                root: {
                    borderWidth: '2px',
                    borderColor: 'text.default',
                    bgColor: 'primary',
                    color: 'background.offWhite',
                },
            },
            special: {
                root: {
                    border: '0',
                    background: 'var(--Cara-gradient, linear-gradient(90deg, #31E2E8 0%, #138DFF 100%))',
                },
                image: {
                    border: '2px solid',
                    borderColor: 'transparent',
                },
            },
        },
        size: {
            md: {
                root: {
                    '--avatar-size': '48px',
                },
            },
        },
    },
    compoundVariants: [],
    defaultVariants: {
        size: 'md',
        variant: 'outline',
    },
});
